import { Add } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  IOrganizationalUnitTeams,
  ITeam,
  createOrganizationalUnitTeams,
  getAllWorkspaceTeams,
} from 'wisestep-api';
import { WsButton, WsDrawer } from 'wisestep-base';

import { ActivateFeature } from '../../../components/ActivateFeature';
import { useWorkspaceContext } from '../../../context';
import TeamsList from '../../../features/jobs/assign/components/TeamsList';
import { TeamAccessAction, useTeamAccessAuthz } from '../../../hooks/useTeamAccessAuthz';
import { success } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';

import CreateTeamModal from './CreateTeamModal';

export interface ICreateTeamButtonProps {
  onEditSuccess: () => void;
  onCreateSuccess: (teamName?: string) => void;
  organizationId?: string;
  filteredTeamList?: ITeam[];
  onFetch?: () => void;
  TeamsOrganizationalUnit?: boolean;
}

interface IWorkspaceTeamsResponse {
  teams: ITeam[];
}

const CreateTeamButton = ({
  onEditSuccess,
  onCreateSuccess,
  organizationId,
  filteredTeamList,
  TeamsOrganizationalUnit,
  onFetch,
}: ICreateTeamButtonProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const [teamsOpen, setteamsOpen] = useState(false);
  const reload = () => setteamsOpen(false);
  const admin = useWorkspaceContext();
  const handleOpen = () => setOpen(true);
  const location = useLocation();
  const path = location.pathname;
  const isOrganizationalUnitPath = path === '/organizational_unit/user-view' ? true : false;

  const handleClose = () => setOpen(false);
  const setNotification = useNotificationStore((state) => state.setNotification);
  const { access: teamAccessControl } = useTeamAccessAuthz([TeamAccessAction.MANAGE_TEAMS_ACCESS]);

  const createAccess = admin.owns || teamAccessControl[0];
  useEffect(() => {
    const getTeams = async () => {
      const workspaceTeamsResponse = await getAllWorkspaceTeams();
      if (workspaceTeamsResponse) {
        const teams: ITeam[] = workspaceTeamsResponse.data;
        const selectedTeams: ITeam[] | undefined = filteredTeamList;
        const uniqueTeams = removeDuplicatesFromArray(teams, selectedTeams, 'id');
        setWorkspaceTeamsResponse({ teams: uniqueTeams });
      }
    };
    getTeams();
  }, [filteredTeamList]);

  const removeDuplicatesFromArray = (sourceArray, filterArray, property) => {
    return sourceArray?.filter(
      (item) => !filterArray?.some((filterItem) => filterItem[property] === item[property])
    );
  };

  const handleDrawerOpen = async () => {
    setteamsOpen(true);
  };
  const [workspaceTeamsResponse, setWorkspaceTeamsResponse] = useState<IWorkspaceTeamsResponse>({
    teams: [],
  });
  const addTeamsOrganizationalUnit = async (data) => {
    if (organizationId) {
      const req: IOrganizationalUnitTeams[] = data.teamsList.map((item) => {
        return {
          organizationalId: organizationId,
          teamId: item,
          viewersIds: [],
        };
      });

      await createOrganizationalUnitTeams(req);
    }
    setteamsOpen(false);
    setNotification(success(`Teams has been added successfully !!`));
    fetchData();
  };
  const fetchData = async () => {
    onFetch && onFetch();
  };
  return (
    <ActivateFeature feature="RS_TEAMS">
      {!isOrganizationalUnitPath ? (
        createAccess && (
          <WsButton startIcon={<Add />} onClick={handleOpen}>
            Create Team
          </WsButton>
        )
      ) : !TeamsOrganizationalUnit ? (
        <WsButton startIcon={<Add />} onClick={handleDrawerOpen}>
          Add Team
        </WsButton>
      ) : null}
      <CreateTeamModal
        open={open}
        onEditSuccess={onEditSuccess}
        onCreateSuccess={onCreateSuccess}
        handleClose={handleClose}
      />
      <WsDrawer
        open={teamsOpen}
        onClose={reload}
        title={'Select Teams'}
        headerSize="medium"
        size="small"
      >
        <TeamsList
          teamsData={workspaceTeamsResponse.teams}
          onAssign={function (): void {}}
          title="Organizational Unit"
          onInput={(data) => {
            addTeamsOrganizationalUnit(data);
          }}
        />
      </WsDrawer>
    </ActivateFeature>
  );
};

export default CreateTeamButton;
